/* Nuvya — scripts des blocs produit (ex-Custom Liquid). Chargé en defer, une seule fois. */
(function () {
  var MOIS = ['JANV.', 'FÉVR.', 'MARS', 'AVR.', 'MAI', 'JUIN', 'JUIL.', 'AOÛT', 'SEPT.', 'OCT.', 'NOV.', 'DÉC.'];
  var JOURS = ['DIM.', 'LUN.', 'MAR.', 'MER.', 'JEU.', 'VEN.', 'SAM.'];

  function initShipDates(root) {
    root.querySelectorAll('[data-nv-ship-date]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.dataset.offset, 10) || 1));
      el.textContent = JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()];
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-nv-slider]').forEach(function (s) {
      if (s.dataset.nvReady) return;
      s.dataset.nvReady = '1';
      var slides = s.querySelectorAll('.nv-slider__slide');
      var dotsWrap = s.querySelector('.nv-slider__dots');
      if (slides.length < 2) return;
      var i = 0, timer, dots = [];
      slides.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv-slider__dot' + (k === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Avis ' + (k + 1));
        b.addEventListener('click', function () { go(k); reset(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
      function go(k) {
        slides[i].classList.remove('is-on'); dots[i].classList.remove('is-on');
        i = (k + slides.length) % slides.length;
        slides[i].classList.add('is-on'); dots[i].classList.add('is-on');
      }
      function reset() {
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, parseInt(s.dataset.interval, 10) || 4000);
      }
      reset();
    });
  }

  function init(root) { initShipDates(root); initSliders(root); }

  // Guide des tailles : <dialog> natif (délégation, fonctionne pour tous les blocs)
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nv-dialog-open]');
    if (open) {
      var dlg = document.getElementById(open.dataset.nvDialogOpen);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-nv-dialog-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nv-dialog')) e.target.close(); // clic sur le fond
  });

  // Mise à jour du « 3 × … € » quand on change de variante (événement du thème Dawn)
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-nv-klarna-part]').forEach(function (el) {
      var n = parseInt(el.dataset.n, 10) || 3;
      var part = (v.price / n / 100).toFixed(2).replace('.', ',');
      el.textContent = n + ' × ' + part + ' €';
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
